import Chip, { chipClasses } from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import { badgeClasses as muiBadgeClasses } from '@mui/material/Badge';
import { badgeClasses } from '../Badge/badgeClasses';
import { svgIconClasses } from '@mui/material/SvgIcon';

export const ChipRoot = styled(Chip, {
  name: 'AFChipSelection',
  shouldForwardProp: prop => prop !== 'size' && prop !== 'isOpen'
})(({ theme, isOpen, size, onDelete, disabled }) => {
  const hasDeleteIcon = !!onDelete;

  const focusedFrame = {
    border: '1px solid transparent',
    boxShadow: `0px 0px 0px 2px ${theme.palette.primary.main}`
  };

  return {
    height: theme.sizes?.chipSelection[size],
    border: `1px solid  ${theme.palette.divider}`,
    backgroundColor: theme.palette.common.white,
    boxShadow: 'none',
    ...(isOpen && focusedFrame),
    ...(disabled && {
      border: `1px solid ${theme.palette.action.disabledBackground}`
    }),
    [`& .${chipClasses.label}`]: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      marginRight: hasDeleteIcon ? theme.spacing(0.5) : null
    },
    [`&.${chipClasses.outlinedPrimary}:not(.Mui-disabled).${chipClasses.outlinedPrimary}`]: {
      '&:focus': {
        ...focusedFrame,
        backgroundColor: theme.palette.common.white
      }
    },
    [`&.${chipClasses.outlinedPrimary}`]: {
      '&.Mui-disabled': {
        boxShadow: 'none'
      }
    },
    [`&.${chipClasses.outlined}`]: {
      [`& .${chipClasses.deleteIcon}`]: {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(-1)
      }
    },
    [`& .${chipClasses.deleteIcon}`]: {
      width: 16,
      height: 16,
      [`&.${svgIconClasses.root}`]: {
        '&:hover': {
          color: theme.palette.grey[800]
        }
      }
    },
    // Counter badge styles on ChipSelection state changes
    [`&:hover:not(:focus) .${muiBadgeClasses.badge}.${badgeClasses.counter}`]: {
      backgroundColor: `transparent`
    }
  };
});
